var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.processo.id
    ? _c(
        "validation-observer",
        { ref: "validation", attrs: { tag: "form" } },
        [
          _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "el-row",
                { staticClass: "margin-medium-top", attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "center", attrs: { span: 8 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Nome do Interessado:",
                          content: _vm.processo.nomeRazaoSocialInteressado
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Número do processo:",
                          content: _vm.processo.numeroProcesso
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "CPF do Interessado:",
                          content: _vm.processo.cpfCnpjInteressado
                        }
                      }),
                      _c("app-display", {
                        attrs: {
                          label: "Tipo de Processo:",
                          content: _vm.processo.tipo.nome
                        }
                      })
                    ],
                    1
                  ),
                  _c("app-opcoes-header-analise", {
                    staticClass: "right",
                    attrs: {
                      idProcesso: _vm.processo.id,
                      numeroProcesso: _vm.processo.numeroProcesso,
                      tipoProcesso: _vm.processo.tipo.codigo,
                      protocolo: _vm.processo.numeroProtocolo,
                      btnSolicitarInformacao: false,
                      btnRetificacao: false
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.step === 1
            ? [
                _vm.exibirSteps
                  ? _c(
                      "el-steps",
                      {
                        staticClass: "mt-20",
                        attrs: {
                          active: _vm.tela,
                          "finish-status": "success",
                          "align-center": "align-center"
                        }
                      },
                      [
                        _c("el-step", {
                          attrs: {
                            title: "Informar dados do documento",
                            status: _vm.tela > 0 ? "success" : "process",
                            icon: "el-icon-edit-outline"
                          }
                        }),
                        _c("el-step", {
                          attrs: {
                            title: "Confirmar dados",
                            status: "process",
                            icon: "el-icon-tickets"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "alinhamento-dados" }, [
                  _vm.tela === 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "validation-observer",
                            { ref: "validation", attrs: { tag: "form" } },
                            [
                              _vm.custasCertidao
                                ? _c(
                                    "form",
                                    {
                                      on: {
                                        submit: function($event) {
                                          $event.preventDefault()
                                          return _vm.onSubmit($event)
                                        }
                                      }
                                    },
                                    [
                                      _vm._l(_vm.custasCertidao, function(
                                        dadosCertidao,
                                        index
                                      ) {
                                        return _c(
                                          "div",
                                          [
                                            _c(
                                              "el-row",
                                              {
                                                attrs: {
                                                  type: "flex",
                                                  gutter: 40
                                                }
                                              },
                                              [
                                                _c("app-display", {
                                                  staticClass:
                                                    "numero-certidao",
                                                  attrs: {
                                                    label: "Certidão nº:",
                                                    content:
                                                      dadosCertidao.numeroCertidao
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "el-row",
                                              {
                                                attrs: {
                                                  type: "flex",
                                                  gutter: 40
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-col",
                                                  [
                                                    _c("validation-provider", {
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Quantidade de Folhas:"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  attrs: {
                                                                    disabled:
                                                                      "disabled"
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .custasCertidao[
                                                                        index
                                                                      ]
                                                                        .quantidadeFolhas,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .custasCertidao[
                                                                          index
                                                                        ],
                                                                        "quantidadeFolhas",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "custasCertidao[index].quantidadeFolhas"
                                                                  }
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "help erro"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  [
                                                    _c("app-label", {
                                                      attrs: {
                                                        label:
                                                          "Quantidade de Módulos:"
                                                      }
                                                    }),
                                                    _c("el-input", {
                                                      staticClass: "input",
                                                      on: {
                                                        change:
                                                          _vm.calcularCustas
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.custasCertidao[
                                                            index
                                                          ].quantidadeModulos,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.custasCertidao[
                                                              index
                                                            ],
                                                            "quantidadeModulos",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "custasCertidao[index].quantidadeModulos"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "app-label",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "Ancianidade do Título :"
                                                                    }
                                                                  }
                                                                ),
                                                                _c("el-input", {
                                                                  staticClass:
                                                                    "input",
                                                                  class: {
                                                                    erro:
                                                                      errors.length
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .custasCertidao[
                                                                        index
                                                                      ]
                                                                        .ancianidade,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .custasCertidao[
                                                                          index
                                                                        ],
                                                                        "ancianidade",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "custasCertidao[index].ancianidade"
                                                                  }
                                                                })
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-col",
                                                  [
                                                    _c("app-label", {
                                                      attrs: {
                                                        label:
                                                          "Valor da Certidão :"
                                                      }
                                                    }),
                                                    _c("app-double-input", {
                                                      staticClass:
                                                        "input-valor",
                                                      attrs: {
                                                        value: _vm.calculoValorCertidao(
                                                          index
                                                        ),
                                                        disable: true,
                                                        prefix: "R$ "
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c("app-divider", {
                                              staticClass: "mb-20",
                                              attrs: { label: "" }
                                            })
                                          ],
                                          1
                                        )
                                      }),
                                      _c(
                                        "el-row",
                                        { attrs: { type: "flex", gutter: 40 } },
                                        [
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Data de Vencimento:"
                                                }
                                              }),
                                              _c("el-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  value: _vm.formatData(
                                                    _vm.dataVencimento
                                                  ),
                                                  "prefix-icon": "el-icon-date",
                                                  disabled: "disabled"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: { label: "Receita:" }
                                              }),
                                              _c("el-input", {
                                                staticClass: "input",
                                                attrs: { disabled: "disabled" },
                                                model: {
                                                  value: _vm.receita,
                                                  callback: function($$v) {
                                                    _vm.receita = $$v
                                                  },
                                                  expression: "receita"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Data do Cálculo:"
                                                }
                                              }),
                                              _c("el-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  value: _vm.dataCalculo,
                                                  "prefix-icon": "el-icon-date",
                                                  disabled: "disabled"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: { label: "Referência:" }
                                              }),
                                              _c("el-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  value: _vm.referencia,
                                                  "prefix-icon": "el-icon-date",
                                                  disabled: "disabled"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: { label: "Valor Total:" }
                                              }),
                                              _c("app-double-input", {
                                                staticClass: "input-valor",
                                                attrs: {
                                                  value: _vm.calculoTotalCustas(),
                                                  disable: true,
                                                  prefix: "R$ "
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("app-divider", {
                                        staticClass: "mb-20",
                                        attrs: { label: "" }
                                      }),
                                      _c(
                                        "el-row",
                                        {
                                          staticClass: "mb-20",
                                          attrs: { type: "flex", gutter: 40 }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Nome/Razão Social:"
                                                }
                                              }),
                                              _c("el-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  value:
                                                    _vm.dadosInteressado
                                                      .nomeRazaoSocial,
                                                  disabled: "disabled"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: { label: "CPF/CNPJ:" }
                                              }),
                                              _c("el-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  value:
                                                    _vm.dadosInteressado
                                                      .cpfCnpj,
                                                  disabled: "disabled"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: {
                                                  label: "Documento de Origem:"
                                                }
                                              }),
                                              _c("el-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  value:
                                                    _vm.processo.numeroProcesso,
                                                  disabled: "disabled"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        {
                                          staticClass: "mb-20",
                                          attrs: { type: "flex", gutter: 40 }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            [
                                              _c("validation-provider", {
                                                attrs: { rules: "required" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("app-label", {
                                                            attrs: {
                                                              label:
                                                                "Município:"
                                                            }
                                                          }),
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticClass:
                                                                "full-width input",
                                                              class: {
                                                                erro:
                                                                  errors.length
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.idMunicipio,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.idMunicipio = $$v
                                                                },
                                                                expression:
                                                                  "idMunicipio"
                                                              }
                                                            },
                                                            _vm._l(
                                                              _vm.municipios,
                                                              function(
                                                                municipio
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key:
                                                                      municipio.id,
                                                                    attrs: {
                                                                      label:
                                                                        municipio.nome,
                                                                      value:
                                                                        municipio.id
                                                                    }
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "help erro"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  703377783
                                                )
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c("validation-provider", {
                                                attrs: { rules: "required" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("app-label", {
                                                            attrs: {
                                                              label: "Endereço:"
                                                            }
                                                          }),
                                                          _c("el-input", {
                                                            staticClass:
                                                              "input",
                                                            class: {
                                                              erro:
                                                                errors.length
                                                            },
                                                            attrs: {
                                                              value:
                                                                _vm.endereco,
                                                              maxlength: "100"
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.endereco,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.endereco = $$v
                                                              },
                                                              expression:
                                                                "endereco"
                                                            }
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "help erro"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1181465849
                                                )
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c("validation-provider", {
                                                attrs: { rules: "required" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function(ref) {
                                                        var errors = ref.errors
                                                        return [
                                                          _c("app-label", {
                                                            attrs: {
                                                              label: "Telefone:"
                                                            }
                                                          }),
                                                          _c("el-input", {
                                                            directives: [
                                                              {
                                                                name: "mask",
                                                                rawName:
                                                                  "v-mask",
                                                                value: [
                                                                  "(##) #####-####",
                                                                  "(##) ####-####"
                                                                ],
                                                                expression:
                                                                  "['(##) #####-####', '(##) ####-####']"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "input",
                                                            class: {
                                                              erro:
                                                                errors.length
                                                            },
                                                            attrs: {
                                                              value:
                                                                _vm.telefone
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.telefone,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.telefone = $$v
                                                              },
                                                              expression:
                                                                "telefone"
                                                            }
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "help erro"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  errors[0]
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  347872352
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        [
                                          _c(
                                            "el-col",
                                            [
                                              _c("app-label", {
                                                attrs: {
                                                  label:
                                                    "Informações Adicionais: ",
                                                  required: false
                                                }
                                              }),
                                              _c("el-input", {
                                                attrs: {
                                                  type: "textarea",
                                                  rows: 5,
                                                  placeholder:
                                                    "Digite o texto...",
                                                  maxlength: "500",
                                                  "show-word-limit":
                                                    "show-word-limit"
                                                },
                                                model: {
                                                  value:
                                                    _vm.informacoesAdicionais,
                                                  callback: function($$v) {
                                                    _vm.informacoesAdicionais = $$v
                                                  },
                                                  expression:
                                                    "informacoesAdicionais"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tela === 1
                    ? _c(
                        "div",
                        [
                          _c("el-divider", [
                            _c("h3", [_vm._v("Dados do documento")])
                          ]),
                          _c(
                            "el-row",
                            {
                              staticClass: "dados-documento",
                              attrs: { gutter: 40 }
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c("app-display", {
                                    attrs: {
                                      label: "Nome/Razão Social:",
                                      content:
                                        _vm.dadosInteressado.nomeRazaoSocial
                                    }
                                  }),
                                  _c("app-display", {
                                    attrs: {
                                      label: "CPF/CNPJ:",
                                      content: _vm.dadosInteressado.cpfCnpj
                                    }
                                  }),
                                  _c("app-display", {
                                    attrs: {
                                      label: "Endereço:",
                                      content: _vm.endereco
                                    }
                                  }),
                                  _c("app-display", {
                                    attrs: {
                                      label: "Município:",
                                      content: _vm.municipio
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c("app-display", {
                                    attrs: {
                                      label: "Telefone:",
                                      content: _vm.telefone
                                    }
                                  }),
                                  _c("app-display", {
                                    attrs: {
                                      label: "Documento Origem:",
                                      content: _vm.processo.numeroProcesso
                                    }
                                  }),
                                  _c("app-display", {
                                    attrs: {
                                      label: "Referência:",
                                      content: _vm.receita
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c("app-display", {
                                    attrs: {
                                      label: "Data de Vencimento:",
                                      content: _vm.formatData(
                                        _vm.dataVencimento
                                      )
                                    }
                                  }),
                                  _c("app-display", {
                                    attrs: {
                                      label: "Data do Cálculo:",
                                      content: _vm.dataCalculo
                                    }
                                  }),
                                  _c("app-display", {
                                    attrs: {
                                      label: "Valor Total:",
                                      content: _vm.formatValor(
                                        _vm.calculoTotalCustas()
                                      )
                                    }
                                  }),
                                  _c("app-display", {
                                    attrs: {
                                      label: "Informações Adicionais:",
                                      content: _vm.informacoesAdicionais
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("el-divider", [
                            _c("h3", [_vm._v("Dados das Certidões")])
                          ]),
                          _vm._l(_vm.custasCertidao, function(
                            dadosCertidao,
                            index
                          ) {
                            return _c(
                              "div",
                              { staticClass: "dados-certidoes" },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 40 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c("app-display", {
                                          attrs: {
                                            label: "Certidão nº:",
                                            content:
                                              dadosCertidao.numeroCertidao
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c("app-display", {
                                          attrs: {
                                            label: "Quantidade de Folhas:",
                                            content:
                                              dadosCertidao.quantidadeFolhas
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c("app-display", {
                                          attrs: {
                                            label: "Quantidade de Módulos:",
                                            content:
                                              dadosCertidao.quantidadeModulos
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c("app-display", {
                                          attrs: {
                                            label: "Ancianidade do Título:",
                                            content: dadosCertidao.ancianidade
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 40 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c("app-display", {
                                          staticClass:
                                            "dados-linha-valor-certidao",
                                          attrs: {
                                            label: "Valor Total da Certidão:",
                                            content: _vm.formatValor(
                                              _vm.calculoValorCertidao(index)
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c("app-display", {
                                          attrs: {
                                            label: "Valor das Folhas:",
                                            content: _vm.formatValor(
                                              dadosCertidao.valorCalculoFolhas
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c("app-display", {
                                          attrs: {
                                            label: "Valor dos Módulos:",
                                            content: _vm.formatValor(
                                              dadosCertidao.valorCalculoModulos
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c("app-display", {
                                          attrs: {
                                            label: "Valor da Ancianidade:",
                                            content: _vm.formatValor(
                                              dadosCertidao.ancianidade *
                                                dadosCertidao.valorAncianidade
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("el-divider")
                              ],
                              1
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]),
                _c("app-buttons-cadastro", {
                  attrs: {
                    isPrimeiroPasso: _vm.isPrimeiroPasso,
                    isUltimoPasso: _vm.tela === 1,
                    showButtonCancelar: _vm.exibirSteps,
                    showButtonProximo: _vm.exibirSteps
                  },
                  on: {
                    cancelar: _vm.cancelar,
                    proximo: _vm.proximo,
                    voltar: _vm.voltar,
                    finalizar: _vm.finaliza
                  }
                })
              ]
            : _vm._e(),
          _vm.step === 2 && _vm.dadosCadastro
            ? [
                _c(
                  "el-card",
                  { staticClass: "card-collapse", attrs: { shadow: "hover" } },
                  [
                    _c("app-despachos", {
                      attrs: {
                        idProcesso: _vm.idProcesso,
                        data: _vm.dadosCadastro.setores
                      },
                      on: {
                        getDownload: _vm.getDownload,
                        getAnotacao: _vm.getAnotacao
                      }
                    })
                  ],
                  1
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e439394c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e439394c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/GerarCustasCertidao.vue
// module id = null
// module chunks = 